import { useEffect, useState } from 'react'
import { IconLoader2 } from '@tabler/icons-react'
import { useTranslation } from '@/hooks/use-translation'

const TIMEOUT_MS = 30_000

interface ActivatingSpinnerProps {
  testId?: string
}

export function ActivatingSpinner({ testId }: ActivatingSpinnerProps) {
  const { t } = useTranslation()
  const [timedOut, setTimedOut] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setTimedOut(true), TIMEOUT_MS)
    return () => clearTimeout(timer)
  }, [])

  return (
    <div
      data-testid={testId ?? 'activating-spinner'}
      className='flex flex-col items-center gap-3 py-16'
    >
      {timedOut ? (
        <p className='text-muted-foreground'>
          {t('Activation pending — refresh page')}
        </p>
      ) : (
        <>
          <IconLoader2 className='h-10 w-10 animate-spin text-primary' />
          <p className='text-muted-foreground'>
            {t('Activating your subscription...')}
          </p>
        </>
      )}
    </div>
  )
}
